import React, { useState } from 'react'
import { Layout } from '..'
import { TextField, Button, Typography, Box } from '@mui/material'
import { AxiosWithAuth } from '../../Utilities/authenticationService'
import PageWithTitleLayout from '../Layout/PageWithTitleLayout'
import SubmitSvg from '../SubmitShift/SubmitSvg'

const ResendConfirmation = ({ history }) => {
    const [email, setEmail] = useState('')
    const [resent, setResent] = useState(false)

    if (resent) {
        return (
            <Layout>
                <div
                    style={{
                        height: 'calc(100vh - 56px)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        margin: '0 1rem'
                    }}
                >
                    <SubmitSvg />
                    <Typography variant="header1" sx={{ fontSize: '20px' }}>
                        メールを送信しました。
                    </Typography>
                    <Button
                        onClick={() => {
                            setResent(null)
                            history.push('/login')
                        }}
                        variant="contained"
                        color="paloBlue"
                        fullWidth
                        sx={{ mt: 'auto', mb: '2rem' }}
                    >
                        ログイン画面へ
                    </Button>
                </div>
            </Layout>
        )
    }

    return (
        <Layout>
            <PageWithTitleLayout title="確認メールの再送">
                <Box className="input-box shrinkable" component="form" autoComplete="off">
                    <Typography
                        variant="subtitle2"
                        sx={{
                            height: '2rem',
                            marginBottom: '.5rem'
                        }}
                    >
                        メールアドレス確認用のメールを再送します。
                    </Typography>
                    <TextField
                        sx={{ marginTop: '1rem' }}
                        label="メールアドレス (Email address) "
                        type="email"
                        placeholder="例：pai@gmail.com"
                        helperText="半角英数字"
                        InputLabelProps={{ shrink: true }}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <Button
                        variant="contained"
                        color="paloBlue"
                        sx={{ marginTop: '1rem', height: '42px' }}
                        disabled={!email}
                        onClick={() => {
                            AxiosWithAuth.post('/resendConfirmation', { email }).then(res => {
                                res.status == 200 && setResent(true)
                            })
                        }}
                    >
                        送信
                    </Button>
                </Box>
            </PageWithTitleLayout>
        </Layout>
    )
}
export default ResendConfirmation
